module.exports = __webpack_public_path__ + "static/media/forside_right_1.af4c605b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/forside_right_1.jpg
// module id = 1470
// module chunks = 0